var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurePython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.873,
    height: 103.577,
    viewBox: "0 0 140.873 103.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    transform: "translate(2515.915 1130.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162",
    transform: "translate(-2515.915 -1130.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    d: "M-2318.862-995.423h-135.43a2.774 2.774 0 0 1-2.721-2.818v-97.94a2.774 2.774 0 0 1 2.721-2.818h135.43a2.774 2.774 0 0 1 2.721 2.818v97.94a2.774 2.774 0 0 1-2.721 2.818zm-135.43-102.168a1.387 1.387 0 0 0-1.361 1.409v97.94a1.387 1.387 0 0 0 1.361 1.409h135.43a1.387 1.387 0 0 0 1.361-1.409v-97.94a1.387 1.387 0 0 0-1.361-1.409z",
    fill: "#017cee",
    "data-name": "Path 1033",
    transform: "translate(2457.013 1099)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155",
    transform: "translate(.981 12.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_453",
    d: "M0 0h139.512v1.361H0z",
    fill: "#017cee",
    "data-name": "Rectangle 453"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159",
    transform: "translate(6.11 5.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    cx: 1.616,
    cy: 1.616,
    r: 1.616,
    fill: "#017cee",
    "data-name": "Ellipse 110"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157",
    transform: "translate(10.342)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    cx: 1.616,
    cy: 1.616,
    r: 1.616,
    fill: "#017cee",
    "data-name": "Ellipse 111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158",
    transform: "translate(5.171)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    cx: 1.616,
    cy: 1.616,
    r: 1.616,
    fill: "#017cee",
    "data-name": "Ellipse 112"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    transform: "translate(47.763 36.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    d: "M-2294.046-997.891a31.447 31.447 0 0 0-5.262.449c-4.659.823-5.5 2.546-5.5 5.724v4.2h11.01v1.4h-15.142a6.875 6.875 0 0 0-6.878 5.582 20.579 20.579 0 0 0 0 11.19c.783 3.259 2.652 5.582 5.852 5.582h3.785v-5.03a7 7 0 0 1 6.878-6.84h11a5.547 5.547 0 0 0 5.505-5.6v-10.484c0-2.984-2.517-5.225-5.505-5.724a34.357 34.357 0 0 0-5.743-.449zm-5.955 3.375a2.089 2.089 0 0 1 2.066 2.1 2.08 2.08 0 0 1-2.065 2.096 2.078 2.078 0 0 1-2.066-2.092 2.087 2.087 0 0 1 2.066-2.104z",
    fill: "#017cee",
    "data-name": "Path 1034",
    transform: "translate(2316.598 997.891)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path1950",
    transform: "translate(11.785 11.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    d: "M-2258.57-963.3v4.889a7.062 7.062 0 0 1-6.878 6.981h-11a5.617 5.617 0 0 0-5.505 5.6v10.484c0 2.984 2.595 4.739 5.505 5.595a18.418 18.418 0 0 0 11 0c2.772-.8 5.5-2.418 5.5-5.595v-4.2h-11v-1.4h16.5c3.2 0 4.393-2.232 5.506-5.582 1.15-3.449 1.1-6.766 0-11.19-.791-3.186-2.3-5.582-5.506-5.582zm-6.185 26.551a2.078 2.078 0 0 1 2.066 2.092 2.086 2.086 0 0 1-2.066 2.1 2.089 2.089 0 0 1-2.066-2.1 2.081 2.081 0 0 1 2.066-2.088z",
    fill: "#017cee",
    "data-name": "Path 1035",
    transform: "translate(2281.951 963.296)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurePython);
export default __webpack_public_path__ + "static/media/PurePython.450e227143b0bef1f7a82a1b8ac72f45.svg";
export { ForwardRef as ReactComponent };